import React from 'react'
import Modal from '../modal'

import './report-segment.scss'
import SimpleValue from './simple-value'
import DonutChart from '../donut-chart'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

function ReportSegment(props) {
  const [detailsOpen, setDetailsOpen] = React.useState(false)
  const toggleDetails = React.useCallback(() => {
    setDetailsOpen(!detailsOpen)
  }, [detailsOpen, setDetailsOpen])

  let classes = 'report-segment'
  if (props.data !== undefined && props.data.content !== undefined) classes += ' has-details'

  return (
    <div className="report-segment-holder">
      <div
        onClick={
          props.data !== undefined && props.data.content !== undefined ? toggleDetails : null
        }
        className={classes}
      >
        <div className="content">
          <h3 className="title">{props.title !== undefined ? props.title : 'Missing title'}</h3>
          <span className="subtitle">
            {props.subtitle !== undefined ? props.subtitle : 'Missing subtitle'}
          </span>
          <div className="description">
            {props.children}
            {props.data !== undefined && props.data.content !== undefined ? (
              <div className="detail-hint">
                <FontAwesomeIcon icon={faInfoCircle} /> Click for details
              </div>
            ) : (
              ''
            )}
          </div>
        </div>

        {props.data === undefined || props.data.chart === undefined ? (
          <SimpleValue icon={props.icon} data={props.data} />
        ) : (
          <DonutChart
            labels={props.data.chart.labels}
            datasets={props.data.chart.datasets}
            centerText={props.data.chart.centerText}
          />
        )}
      </div>
      {props.data !== undefined && props.data.content !== undefined ? (
        <Modal
          data={props.data.content}
          title={props.title}
          open={detailsOpen}
          toggleModal={toggleDetails}
        />
      ) : (
        ''
      )}
    </div>
  )
}

export default ReportSegment
